module.exports = __webpack_public_path__ + "img/042d3fb.jpg";